module.exports = __webpack_public_path__ + "img/background_mobile.a3bd0ca.webp";